import { render, staticRenderFns } from "./EditCategoryPage.vue?vue&type=template&id=6edf2f9c"
import script from "./EditCategoryPage.vue?vue&type=script&lang=js"
export * from "./EditCategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports